import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Default site info — overridden at runtime by /api/settings
export const DEFAULT_SITE = {
  brand: "Sithonia Holidays",
  phone: "+30 6971819748",
  phone_display: "+30 697 181 9748",
  whatsapp: "306971819748",
  email: "info@sithoniaholidays.gr",
  address: "Nikiti, Sithonia, Halkidiki, Greece",
  maps_link: "https://maps.app.goo.gl/1sXpVnPmRubUHaNm6",
  maps_embed: "https://www.google.com/maps?q=Nikiti+Sithonia+Halkidiki&output=embed",
  facebook_url: "",
  instagram_url: "",
  hero_image: "/photos/hero.jpg",
};

export const resolveImage = (src) => {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("/")) return src;
  return `/${src}`;
};

// Backwards-compat shim used by older imports
export const SITE = {
  brand: DEFAULT_SITE.brand,
  phone: DEFAULT_SITE.phone,
  phoneDisplay: DEFAULT_SITE.phone_display,
  whatsapp: DEFAULT_SITE.whatsapp,
  email: DEFAULT_SITE.email,
  address: DEFAULT_SITE.address,
  mapsLink: DEFAULT_SITE.maps_link,
  mapsEmbed: DEFAULT_SITE.maps_embed,
};
